import { useTranslation } from 'react-i18next'
import { AppShell } from '../shared/ui/AppShell'
import { AnalyticsDashboard } from '../shared/ui/AnalyticsDashboard'

export function AnalyticsPage() {
  const { t } = useTranslation()

  return (
    <AppShell showAnalytics={false} showTopBar>
      <div className="mx-auto w-full max-w-[1400px] py-2 lg:px-2 lg:py-4">
        <h1 className="mb-3 text-lg font-bold text-foreground lg:text-xl">
          {t('analytics.title')}
        </h1>
        <AnalyticsDashboard variant="page" />
      </div>
    </AppShell>
  )
}
